import * as React from 'react';
import {v4 as uuidv4} from 'uuid';
import {
    LoadingSpinner,
    VenueRecommendationsCell
} from '@weddingspot/ws-core-components';
import {
    Venues,
    RecommendationsLogs,
    RecommendationsLogsApi
} from '@weddingspot/ws-api-client';

const styles = require('./VenueRecommendations.scss');

export interface RecommendedVenuesProps {
    logRecommendation?: boolean;
    venueId?: number;
    recommendations: Venues.VenueRecommendation[];
    recommendationsLoadSucceeded: boolean | undefined;
    onRecommendationClick?: (position: number, recommenations: Venues.VenueRecommendation[]) => void;
    renderRdv: boolean;
    hideHeadline?: boolean;
}

export default class RecommendedVenues extends React.Component<RecommendedVenuesProps> {
    state = {
        sessionId: uuidv4()
    };

    constructor(props: RecommendedVenuesProps) {
        super(props);
        this.handleRecommendationClick = this.handleRecommendationClick.bind(this);
    }

    componentDidMount(): void {
        if (this.props.venueId && this.props.logRecommendation){
            RecommendationsLogsApi.getRecommendationsLogs(
                {
                    from_venue_id: this.props.venueId,
                    to_venue_ids: this.props.recommendations.map(i => i.id),
                    source: RecommendationsLogs.RecommendationsLogsSources.PROFILE_V2_RECOMMENDATION_SOURCE,
                    algorithm: RecommendationsLogs.RecommendationsLogsAlgorithms.LEGACY,
                    session_id: this.state.sessionId,
                });
        }
    }

    public render() {
        if (this.props.recommendationsLoadSucceeded === false) {
            return this.renderFailedState();
        }

        return (
            <div>
                {!this.props.hideHeadline && <h3 className={styles.headline}>Other venues you might like...</h3>}
                <div className={styles.recommendations}>
                    {this.props.recommendationsLoadSucceeded === undefined && <LoadingSpinner />}
                    {this.props.recommendationsLoadSucceeded && this.renderRecommendations()}
                </div>
            </div>
        );
    }

    private handleRecommendationClick(position: number) {
        const recommendation = this.props.recommendations[position];
        if (this.props.venueId && this.props.logRecommendation) {
            RecommendationsLogsApi.activateRecommendationsLogs(
                {
                    session_id: this.state.sessionId,
                    to_venue_id: recommendation.id
                });
        }
        if (this.props.onRecommendationClick) {
            this.props.onRecommendationClick(position, this.props.recommendations);
        }
    }

    private renderRecommendations() {
        return this.props.recommendations.map((props, idx) => {
            let cellProps = { ...props };

            // Hide budget for RDvs
            if (this.props.renderRdv) {
                cellProps = {
                    ...cellProps,
                    budget_capacity: undefined,
                    budget_min: undefined,
                };
            }

            return (
                <div className={styles.cellContainer} onClick={() => this.handleRecommendationClick(idx)} key={idx}>
                    <VenueRecommendationsCell position={idx} {...cellProps} />
                </div>
            );
        });
    }

    private renderFailedState() {
        // Just render nothing
        return null;
    }
}
